import React from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import { ErrorPage } from "../components/error-page";
import { Layout } from "../layout";
import { ChatRoom } from "../pages/chatroom";
import { Home } from "../pages/home";

export const PageRouter: React.FC = () => (
  <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chatroom" element={<ChatRoom />}>
          <Route path="/chatroom/:chatRoomId" element={<ChatRoom />} />
        </Route>
        <Route path="network-error" element={<ErrorPage />} />
      </Routes>
    </Layout>
  </BrowserRouter>
);
